<!-- 证据提取 -->
<template>
  <div>
    <common-header></common-header>
    <div class="internetCourt">
      <div class="interbanimg">
        <pub-animate>
          <div class="bannerContent" v-show="showNavPic">
            <div class="left" :style="{'top':$route.path.indexOf('en')==1?'24%':'30%'}">
              <div class="left-title">{{lanInfo.speed}}</div>
              <div class="left-cont" v-html="lanInfo.towen"></div>
            </div>
            <div class="right">
              <img
                class="enlarge"
                src="~img/evidenceExtraction/index/zjtq_banner_zt_img.png"
                alt
                srcset
              />
            </div>
          </div>
        </pub-animate>
        <div class="login-area" @keydown.enter="extract">
          <p>{{lanInfo.areaTitle}}</p>
          <div class="info-row">
            <input
              class="username"
              :placeholder="lanInfo.input_1"
              v-model="extractingCode"
              @blur="checkExtractingCode"
            />
            <span class="err-tips" v-if="showerr_extracting">{{tips.extractingCode}}</span>
          </div>
          <div class="vcode-area info-row clearfix">
            <input :placeholder="lanInfo.input_2" v-model="vcode" @blur="checkVcode" />
            <img :src="notaryVcodeUrl" @click="getVcode" />
            <span class="err-tips" v-if="showerr_vcode">{{tips.vcode}}</span>
          </div>
          <button @click="extract" :class="['extract-color',success?'extract-pendding':'']">{{lanInfo.search}}</button>
        </div>
      </div>
    </div>
    <loading-absolute v-if="$store.state.showLoading"></loading-absolute>
  </div>
  
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import LoadingAbsolute from '../common/LoadingAbsolute'
  export default {
    data() {
      return {
        success:false,
        showNavPic: false,
        showerr_extracting:false,
        showerr_vcode:false,
        notaryVcodeUrl: "",
        extractingCode: "",
        vcode: "",
        tips: {
          extractingCode: "",
          vcode: ""
        },
        loadedTime: 0,
        defaultECode:"",//证据提取分享的提取码
        isShowComHeader:true
      };
    },
    components: {
      LoadingAbsolute
    },
    mounted() {
      this.extractingCode=this.$route.query?this.$route.query.code:'';
      // console.log(this.$route.query.code,"分享的提取码")
      this.getVcode();
      setTimeout(() => {
        this.showNavPic = true;
      }, 100);
    },
    methods: {
      //更换验证码
      getVcode() {
        this.$ajax
          .get("/webapi/common/getCode")
          .then(res => {
            if (res.data.code == 200) {
              // "data:image/png;base64," 
              this.notaryVcodeUrl = "data:image/png;base64,"+res.data.extraData.code;
            } 
          });
      },
      //校验提取码
      checkExtractingCode() {
        if (this.extractingCode) {
  
          this.showerr_extracting=false;
          return true;
        } else {
           this.showerr_extracting=true;
          this.tips.extractingCode = this.lanInfo.input_1;
          return false;
        }
      },
      //校验验证码
      checkVcode() {
        if (this.vcode) {
          if (/^([a-z]|[A-Z]|[0-9]){4}$/.test(this.vcode)) {
            this.showerr_vcode=false;
            return true;
          } else {
             this.showerr_vcode=true;
               this.tips.vcode=this.lanInfo.err_2
               return false;
          }
        } else {
          this.showerr_vcode=true;
          this.tips.vcode=this.lanInfo.void_vCode
          return false;
        }
      },
      extract() {
        let res = this.checkExtractingCode() && this.checkVcode();
        if (res) {
          this.success=true;
          this.$ajax
            .get( "/webapi/extractEvidence/checkExtractType",
              {
                params: {
                  extractingCode: this.extractingCode.trim(),
                  vcode: this.vcode
                }
              }
            )
            .then(response => {
                this.success=false;
              // console.log(response.data.body,"提取结果");
              let data = JSON.parse(response.data.body);
              // console.log(data)
              if (data.code == 200) {
                this.tips.vcode = "";
                this.tips.extractingCode = "";
                this.$router.push({
                  path: "extractionDetail",
                  query: {
                    extractingCode: this.extractingCode.trim(),
                    pageSize: 10,
                    partnerId:data.extraData.partnerId,
                    pageNumber: 1,
                    type:1
                  }
                });
              } else if (data.code == 3012) {
                 this.showerr_vcode=true;
                this.tips.vcode = data.message;
                this.getVcode();
              } else if (data.code == 606) {
                   this.showerr_extracting=true;
                this.tips.extractingCode =this.lanInfo.err_4;
                this.getVcode();
              }  else if (data.code == 1005) {
                 this.showerr_vcode=true;
                this.tips.vcode = this.lanInfo.err_3;
                this.getVcode();
              }else if (data.code == 607) {
                this.showerr_extracting=true;
                this.tips.extractingCode =this.lanInfo.err_5;
                this.getVcode();
              } else {
                this.$message.error("错误哦，请求接口失败了");
                this.$store.dispatch("showMsgModal", {
                  autoClose: true,
                  info: data.message
                });
              }
            });
        } else {
          this.checkExtractingCode();
          this.checkVcode();
        }
      }
    },
    computed: {
      ...mapGetters(["getLanInfo"]),
      lanInfo() {
        return this.getLanInfo.evidenceExtraction;
      }
    },	
    watch:{
        '$route' () {
          let pos = this.$router.history.current.path.indexOf("cn");
          if (pos) {
                // 下载列表
               this.tips.extractingCode= this.lanInfo.input_1;
                this.tips.vcode = this.lanInfo.err_2;
          }
        }
      }
  };
  </script>
  
  <style scoped  lang="scss">
  .internetCourt {
    position: relative;
    z-index: 0;
    width: 100%;
    background-color: #152956;
  }
  .interbanimg {
    position: relative;
    overflow: hidden;
    width: 1200px;
    margin: 0 auto;
    height: 480px;
    .bannerContent {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      height: 470px;
      .left {
        position: absolute;
        left: 0;
        top: 32%;
        color: #ffffff;
        &-title {
          height: 44px;
          line-height: 44px;
          font-size: 32px;
          font-weight: 400;
        }
        &-cont {
          margin-top: 18px;
          line-height: 26px;
              font-size: 14px;
        }
      }
      .right {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 406px;
        height: 295px;
      }
    }
    .login-area {
      position: absolute;
      top: 50%;
      right: 0;
      width: 310px;
      height: 225px;
      float: right;
      background: #fff;
      padding: 20px 20px 0;
      border: 1px solid lightgray;
      z-index: 10;
          margin-top: -113.5px;
      p {
        width: 100%;
        /*margin-top: 26px;*/
        font-size: 18px;
        line-height: 18px;
        text-align: center;
        color: #424446;
      }
      input {
        height: 36px;
        background-color: #ffffff;
        border: solid 1px #dcdcdc;
        font-size: 14px;
        padding-left: 38px;
      }
      .info-row {
        margin-top: 20px;
        position: relative;
        span.err-tips {
          position: absolute;
          left: 0px;
          top: 38px;
          color: #c45;
          font-size: 12px;
        }
      }
      & > input {
        width: 100%;
      }
      .username {
        background: url("~img/evidenceExtraction/index/code_icon.png") no-repeat;
        background-position: 11px center;
        width: 100%;
      }
      .vcode-area {
        margin-top: 20px;
        width: 100%;
        input {
          width: 179px;
          float: left;
          background: url("~img/evidenceExtraction/index/verification_icon.png")
            no-repeat;
          background-position: 11px center;
        }
        img {
          float: right;
          width: 80px;
          height: 36px;
        }
      }
     
    }
    .extract-color{
      background:#c03026;
       margin-top: 20px;
        width: 100%;
        height: 36px;
        font-size: 18px;
        line-height: 36px;
        text-align: center;
        color: #ffffff;
    }
    .extract-pendding{
      background: #e9e7e7;
    }
     .extract-color:hover{
       background:#a2170d;
     }
  }
  </style>